/**
 * View controller for the createAccount subview.
 * @constructor
 * @extends {Foundation.Component}
 * @param {string} id
 */
Foundation.Login.Dialog.CreateAccountComponent = class extends Foundation.Component {
  constructor (id) {
    super(id)

    /** @type {Foundation.Form} */
    this.form = null

    this.observe("shown", () => {
      if (!this.form) {
        this.form = this.registerForm(new Foundation.Form(this.view.find("form")[0]));
        this.form.setSubmitDelegate(this.createAccount.bind(this));
        this.observe("hidden", this.form.cancelSubmit.bind(this.form));
      }
    })
  }

  /**
   * Handle the create account form submission.
   * @param {Object.<string,*>} values
   * @return {!Foundation.Promise}
   */
  createAccount (values) {
    var commit = new Foundation.Promise()
    var member = Foundation.Login.Dialog.activeDialog.member()
    var loginAttempt = new Foundation.Login.Attempt(member)

    member.set("oid", "new")
    member.extend(values)
    var faultResult = member.fault()
    faultResult
      .then(function () {
        loginAttempt.forEmail(/** @type {string} */ (values["email"]))
        loginAttempt.withPassword(/** @type {string} */ (values["password"]))
        commit.marry(loginAttempt.performAttempt())
      })
      .otherwise(function () {
        commit.marry(faultResult)
      })

    return commit
  }
}
